export function addProtocol(url: string, ssl = true): string {
  const protocol = ssl ? "https" : "http";
  return url.startsWith("http") ? url : `${protocol}://${url}`;
}
